import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_URL, handleSendMessage, syncItems } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import React, { useEffect, useState } from "react";
import TabBase from "./components/tab-base";
import SkeltonProgress from "src/components/SkeltonProgress";
import { IBaseAgreement } from "src/interface/IBaseAgreements";
import { IBaseAgreementItem } from "src/interface/IBaseAgreementItem";
import { getRoutes } from "src/utilities/routes";
import { IBaseAgreementFollowup } from "src/interface/IBaseAgreementFollowup";
import moment from "jalali-moment";

const validationSchema = Yup.object({
  name: Yup.string().required("این فیلد الزامی است"),
});

interface NewBaseProps {
  open: boolean;
  handleClose: () => void;
  refetch: any;
  isEdit: boolean;
  serviceId?: number;
  setServiceId: (serviceId?: number) => void;
}

const NewBase = ({
  open,
  handleClose,
  refetch,
  isEdit = false,
  serviceId,
  setServiceId,
}: NewBaseProps) => {
  const Routes = getRoutes();
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.BaseAgreementsRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [data, setData] = useState<IBaseAgreement>();

  const { mutateAsync: getById, isPending: getByIdPending } = useMutation({
    mutationFn: async () => {
      const response = await fetch(Routes.BaseAgreementsRoutes + serviceId, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      return await response.json();
    },
    onSuccess: (responseData: IBaseAgreement) => {
      setData(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    serviceId && getById();
  }, [serviceId]);

  useEffect(() => {
    if (data && isEdit) {
      formik.setValues(data);
      setBaseItems(data.baseAgreementItems ?? []);
      setBaseFollowups(data.followups ?? []);
    }
  }, [data]);
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.BaseAgreementsRoutes + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const {
    mutateAsync: insertServiceItemAsync,
    isPending: isPendingServiceItem,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.BaseAgreementItemsRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: updateServiceItemAsync,
    isPending: isPendingServiceItemEdit,
  } = useMutation({
    mutationFn: async (body: IBaseAgreementItem) => {
      const response = await fetch(Routes.BaseAgreementItemsRoutes + body.id, {
        method: "Put",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      console.log(response);

      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: deleteServiceItemAsync,
    isPending: isDeleteServiceItemLoading,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.BaseAgreementItemsRoutes + body.id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const {
    mutateAsync: insertServiceFollowupAsync,
    isPending: isPendingServiceFollowup,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.BaseAgreementFollowupsRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: updateServiceFollowupAsync,
    isPending: isPendingServiceFollowupEdit,
  } = useMutation({
    mutationFn: async (body: IBaseAgreementFollowup) => {
      const response = await fetch(
        Routes.BaseAgreementFollowupsRoutes + body.id,
        {
          method: "Put",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
        }
      );

      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: deleteServiceFollowupAsync,
    isPending: isDeleteServiceFollowupLoading,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(
        Routes.BaseAgreementFollowupsRoutes + body.id,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Aceept: "application/json",
          },
        }
      );
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const notifications = useNotifications();
  const [baseItems, setBaseItems] = useState<IBaseAgreementItem[]>([]);
  const [baseFollowups, setBaseFollowups] = useState<IBaseAgreementFollowup[]>(
    []
  );

  const formik = useFormik<IBaseAgreement>({
    initialValues: {
      baseAgreementItems: undefined,
      name: "",
      discount: 0,
      isActive: false,
    }, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let res: any;
      if (isEdit) {
        res = await updateAsync(values);
      } else {
        // TODO سال جاری رو بذاری جای تاریخ شروع اولین پیگیری
        // TODO هشدار بدیم که روز تاریخ اولین پیگیری نباید از 30 بیشتر باشد
        // TODO اگر تاریخ پایه قرارداد عوض شد بره تمامی تاریخ شروع پیگیری های قرار داد های سال جاری رو عوض کنه

        res = await insertAsync({ ...values });
      }

      if (res.status === true) {
        /*
        // if (
        //   isEdit &&
        //   data?.baseAgreementItems &&
        //   data?.baseAgreementItems?.length > 0
        // ) {
          // حذف خدماتی که از لیست آیتم خدمات حذف شده اند
        //   data?.baseAgreementItems?.map(async (s: IBaseAgreementItem) => {
        //     if (!baseItems.find((service) => service.id === s.id))
        //       await deleteServiceItemAsync(s.id as number);
        //   });
        // }

        // if (isEdit && baseItems.length > 0) {
        //   baseItems.map(async (item) => {
        //     // اگر آیتم خدمت در لیست آیتم های خدمت های دیتابیس وجود داشت آن را ویرایش کند
        //     if (
        //       data?.baseAgreementItems?.find(
        //         (service: IBaseAgreementItem) => service.id === item.id
        //       )
        //     )
        //       await updateServiceItemAsync(item);
        //     // اگر آیتم خدمت در لیست آیتم های خدمت های دیتابیس وجود نداشت آن را اضافه کند
        //     else
        //       await insertServiceItemAsync({
        //         ...item,
        //         baseAgreementRef: res.data?.id,
        //       });
        //   });
        // }
        // // اگر خدمت جدیدی اضافه شده بود
        // else if (!isEdit && baseItems.length > 0) {
        //   baseItems.map(async (item) => {
        //     await insertServiceItemAsync({
        //       ...item,
        //       baseAgreementRef: res.data?.id,
        //     });
        //   });
        // } */

        try {
          await syncItems<IBaseAgreementItem>({
            deleteItemAsync: deleteServiceItemAsync,
            existingItems: data?.baseAgreementItems ?? [],
            insertItemAsync: insertServiceItemAsync,
            isEdit: isEdit,
            RefField: "baseAgreementRef",
            RefValue: res?.data?.id,
            updatedItems: baseItems,
            updateItemAsync: updateServiceItemAsync,
          });
        } catch (error) {
          console.log(error);
          handleSendMessage(
            notifications,
            "خطا در ذخیره سازی آیتم های پایه قرار داد",
            "error"
          );
        }
        const convertedFollowups = baseFollowups.map((followup) => {
          return {
            ...followup,
            followupAt: new Date(followup.followupAt ?? ""),
          };
        });

        try {
          await syncItems<IBaseAgreementFollowup>({
            deleteItemAsync: deleteServiceFollowupAsync,
            existingItems: data?.followups ?? [],
            insertItemAsync: insertServiceFollowupAsync,
            isEdit: isEdit,
            RefField: "baseAgreementRef",
            RefValue: res?.data?.id,
            updatedItems: convertedFollowups,
            updateItemAsync: updateServiceFollowupAsync,
          });
        } catch (error) {
          console.log(error);
          handleSendMessage(
            notifications,
            "خطا در ذخیره سازی پیگیری های پایه قرار داد",
            "error"
          );
        }

        handleSendMessage(
          notifications,
          "پایه قرارداد جدید با موفقیت ثبت شد!",
          "success"
        );
        setBaseItems([]);
        Close();
      } else {
        handleSendMessage(notifications, "خطا در ذخیره سازی!", "error");
      }
      formik.resetForm();
      setServiceId(undefined);
      refetch();
    },
  });

  const Close = () => {
    handleClose();
    setServiceId(undefined);
    formik.resetForm();
    setBaseItems([]);
    setBaseFollowups([]);
    setData(undefined);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={Close}
        maxWidth="xl"
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
          sx: {
            width: "100%",
          },
        }}
      >
        <DialogTitle>
          {isEdit
            ? "ویرایش پایه قرارداد '" + data?.name + "'"
            : "پایه قرارداد جدید"}
        </DialogTitle>
        <DialogContent>
          {serviceId && getByIdPending ? (
            <SkeltonProgress />
          ) : (
            <TabBase
              formik={formik}
              baseAgreementItems={baseItems}
              setBaseAgreementItem={setBaseItems}
              baseAgreementFollowups={baseFollowups}
              setBaseAgreementFollowups={setBaseFollowups}
            />
          )}
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={
              isPending ||
              isPendingServiceItem ||
              isDeleteServiceItemLoading ||
              isEditLoading ||
              isDeleteServiceFollowupLoading ||
              isPendingServiceFollowup ||
              isPendingServiceItemEdit ||
              isPendingServiceFollowupEdit
            }
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={Close}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewBase;
